module.exports = __webpack_public_path__ + "images/f2e6b0b3f2833c8a162c18ca9d1cfa3c.svg";